var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Box, IconButton, Stack } from "@mui/material";
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import DeleteIcon from '@mui/icons-material/Delete';
import { LoadingButton } from "@mui/lab";
import { CloudinaryService } from "../services/cloudinary.service";
import { useRef, useState } from "react";
import { getScaledUrl, MediaSize } from "../utils/media.util";
import { CommonThemeColors } from "./theme";
import Button from "@mui/material/Button";
import { useSnackbar } from "notistack";
import { useLocalize } from "../utils/text.util";
import { useReadOnly } from "../utils/hooks/users/useReadOnly";
var ButtonImagePicker = function (_a) {
    var image = _a.image, setImage = _a.setImage, width = _a.width, height = _a.height, id = _a.id, objectFit = _a.objectFit, disabled = _a.disabled, allowedRatios = _a.allowedRatios, previewAspectRatio = _a.previewAspectRatio, hint = _a.hint, buttonLabel = _a.buttonLabel, onAfterUpload = _a.onAfterUpload, onAfterDelete = _a.onAfterDelete;
    var _b = useState(null), selectedRatio = _b[0], setSelectedRatio = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var fileInputRef = useRef(null);
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var t = useLocalize().t;
    // Read-only users cannot upload or remove images anywhere in the app.
    var readOnly = useReadOnly();
    var isDisabled = disabled || readOnly;
    var openFilePicker = function () {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var handleDeleteImage = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setImage === null || setImage === void 0 ? void 0 : setImage(undefined);
                    return [4 /*yield*/, (onAfterDelete === null || onAfterDelete === void 0 ? void 0 : onAfterDelete())];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleFileSelected = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var file, result, newImage, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                    if (!file)
                        return [2 /*return*/];
                    e.target.value = '';
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, CloudinaryService.upload(file)];
                case 2:
                    result = _b.sent();
                    if (!(result === null || result === void 0 ? void 0 : result.secure_url))
                        throw new Error('Upload failed');
                    newImage = {
                        mediaURI: result.secure_url,
                        publicId: result.public_id,
                        provider: 'cloudinary'
                    };
                    setImage === null || setImage === void 0 ? void 0 : setImage(newImage);
                    return [4 /*yield*/, (onAfterUpload === null || onAfterUpload === void 0 ? void 0 : onAfterUpload(newImage))];
                case 3:
                    _b.sent();
                    enqueueSnackbar(t("Image uploaded successfully"), { variant: "success" });
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _b.sent();
                    enqueueSnackbar((error_1 === null || error_1 === void 0 ? void 0 : error_1.status) ? t(error_1.status) : t("Image upload failed"), { variant: "error" });
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var imageSource = getScaledUrl(image, MediaSize.LARGE_600, MediaSize.LARGE_600);
    var aspectRatio = image && previewAspectRatio
        ? (function () {
            var _a = previewAspectRatio.split(":").map(Number), w = _a[0], h = _a[1];
            return w && h ? w / h : undefined;
        })()
        : undefined;
    var fileInput = (_jsx("input", { ref: fileInputRef, type: "file", accept: "image/png,image/jpeg,image/jpg", style: { display: 'none' }, onChange: handleFileSelected }));
    if (!imageSource) {
        return (_jsxs(Box, __assign({ id: id }, { children: [fileInput, !isDisabled && (_jsx(LoadingButton, __assign({ variant: "contained", color: 'secondary', loading: loading, startIcon: _jsx(AddPhotoAlternateIcon, {}), onClick: openFilePicker }, { children: buttonLabel || t("Upload image") }))), hint && (_jsx(Box, __assign({ sx: { mt: 1 } }, { children: _jsx(Alert, __assign({ severity: "info" }, { children: _jsx(Box, __assign({ sx: { pt: 0.5 } }, { children: hint })) })) })))] })));
    }
    return (_jsxs(Box, __assign({ id: id, sx: __assign({ position: 'relative', marginBottom: '10px', width: width || 230 }, (aspectRatio
            ? { aspectRatio: aspectRatio }
            : { height: height || 230 })) }, { children: [fileInput, _jsx("img", { src: imageSource, alt: "", style: {
                    width: "100%",
                    height: "100%",
                    borderRadius: 8,
                    objectFit: objectFit || 'cover',
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                    display: "block"
                } }), !isDisabled && (_jsxs(Box, __assign({ sx: {
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    gap: 2,
                    background: 'linear-gradient(0deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%)',
                    paddingBottom: '5px',
                    paddingTop: '5px'
                } }, { children: [allowedRatios && allowedRatios.length > 1 ? (_jsx(Stack, __assign({ direction: "row", spacing: 1 }, { children: allowedRatios.map(function (ratio) {
                            var isActive = ratio === selectedRatio;
                            return (_jsx(Button, __assign({ variant: isActive ? "contained" : "outlined", color: isActive ? "secondary" : undefined, sx: {
                                    bgcolor: isActive ? undefined : "#fff",
                                    "&:hover": {
                                        bgcolor: isActive ? undefined : "#ccc",
                                    },
                                }, size: "small", onClick: function () { return setSelectedRatio(ratio); } }, { children: ratio }), ratio));
                        }) }))) : null, _jsx(IconButton, __assign({ onClick: openFilePicker }, { children: _jsx(AddPhotoAlternateIcon, { sx: {
                                width: "24px",
                                height: "24px",
                                color: CommonThemeColors.sys.primary.contrastText,
                            } }) })), _jsx(IconButton, __assign({ onClick: handleDeleteImage }, { children: _jsx(DeleteIcon, { sx: {
                                width: '24px',
                                height: '24px',
                                color: CommonThemeColors.sys.primary.contrastText
                            } }) }))] }))), hint && (_jsx(Box, __assign({ sx: { mt: 1 } }, { children: _jsx(Alert, __assign({ severity: "info" }, { children: _jsx(Box, __assign({ sx: { pt: 0.5 } }, { children: hint })) })) })))] })));
};
export default ButtonImagePicker;
